import React, {useRef, useState} from 'react'
import { Link } from "react-router-dom";
import '../../components/popup/Popup.css'
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ClipLoader from "react-spinners/ClipLoader"; 
import Autocomplete from "react-google-autocomplete";
import ReCAPTCHA from 'react-google-recaptcha';

const SolutionPopup = ({ prm, closePopup }) => {
  // Zoho scope : ZohoCRM.modules.ALL
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const mapApiKey = process.env.REACT_APP_GOOGLE_PLACE_API_KEY;
  const recaptchaKey = process.env.REACT_APP_GOOGLE_RECAPTCHA_KEY;
  const [isChecked, setIsChecked] = useState(true);
  const [disableButton, setDisableButton] = useState(false);

  const recaptchaRef = useRef(null);
  const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);  
  const [isValidCaptcha, setIsValidCaptcha] = useState("");

  const handleCaptchaChange = (token) => {
    setIsCaptchaVerified(!!token);
  };

  const resetCaptcha = () => {
    recaptchaRef.current?.reset();
    setIsCaptchaVerified(false);
    setIsValidCaptcha("Valid");
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors({});
      return;
    }     
  };

  const toggleDisableButton = () => {
    setDisableButton(!disableButton);
    setIsChecked(!isChecked);
  };    
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Optional, for smooth scrolling
    });
  }; 

  const getInitialState = () => {
    const value = prm;
    return value;
  };  
  
  const [enquiry, setEnquiry] = useState(getInitialState);
  const dropdownHandleChange = (e) => {
    setEnquiry(e.target.value);
  };
 
const [firstName, setFirstName] = useState("");
const [lastName, setLastName] = useState("");
const [phone, setPhone] = useState("");
const [email, setEmail] = useState("");
const [location, setLocation] = useState("");    
const [errors, setErrors] = useState({});
const [spinnerClass, setSpinnerClass] = useState('invisible');
const [isVisible, setIsVisible] = useState('visible');  
const [showMessage, setShowMessage] = useState('invisible');  
const [msg, setMsg] = useState("");

const changeClass = () => {
  setSpinnerClass('visible');
  setIsVisible('invisible');
}
const validateForm = () => {
  const errors = {};
  if (!firstName) {
      errors.firstName = "First name is required";
  }
  if (!lastName) {
      errors.lastName = "Last name is required";
  }
  if (!phone) {
      errors.phone = "Contact number is required";
  }    
  if (!location) {
    errors.location = "Location is required";
  }
  if (isCaptchaVerified === false) {
    errors.isValidCaptcha = "Please verify the CAPTCHA before submitting";
  }   
  return errors;
};

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate form fields
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    if (!isCaptchaVerified) {
      return;
    }    
    changeClass();
    const apiUrl = apiBaseUrl + `sendmail?form_type=3&enquiry_type=${enquiry}&first_name=${firstName}&last_name=${lastName}&contact_number=${phone}&email=${email}&location=${location}&message=`;
    await axios.get(apiUrl).then((res)=>{
        setSpinnerClass('invisible');
        setIsVisible('visible');
        //console.log('Send Data:', res);
        if (res.data.success === true) {
            toast("Data sent successfully");
            setFirstName("");
            setLastName("");
            setPhone("");
            setEmail("");
            setLocation("");
            setEnquiry(getInitialState);
        } else {
            toast(res.data.error || "Data not sent");
        }        
      }).catch((err)=>{
        //console.log('Invalid Email :', err);
        setSpinnerClass('invisible');
        setIsVisible('visible');
        toast("Something went wrong. Please try again later.");
    })
  };

  return (
    <div className="popup-container">     
        <div className="popup-body solution-form">
          <ToastContainer />
            <button className='btnclose' onClick={closePopup}>&times;</button>            
             <div className="appointment-form-wrapper clearfix">
                <form className="appoinment-form" onSubmit={handleSubmit}> 
                     <div className="form-group col-md-12">
                        <label>Enquiry type</label>
                        <div className="select-style">                                    
                        <select 
                          className="form-control" 
                          name="enquiry_type"
                          value={enquiry}
                          onChange={dropdownHandleChange}>
                            <option value={'Residential'} selected={prm ==='Residential' ? true : false}>Residential</option>
                            <option value={'Housing Society'} selected={prm ==='Housing Society' ? true : false}>Housing Society</option>
                            <option value={'Commercial'} selected={prm ==='Commercial' ? true : false}>Commercial</option>
                            <option value={'Industrial'} selected={prm ==='Industrial' ? true : false}>Industrial</option>
                            <option value={'Institutional'} selected={prm ==='Institutional' ? true : false}>Institutional</option>
                            <option value={'Floating'} selected={prm ==='Floating' ? true : false}>Floating</option>
                            <option value={'Other'} selected={prm ==='Other' ? true : false}>Others</option>
                        </select>
                        </div>
                        
                    </div>
                    <div className="form-group col-md-6">
                        <label>First name <span className="text-danger"><strong>*</strong></span></label>
                        <input 
                            className="form-control" 
                            placeholder="First name" 
                            type="text" 
                            name="first_name"
                            value={firstName}
                            onChange={(e) => setFirstName(e.target.value)}
                            autoComplete="false"                            
                            required/>
                            {errors.firstName && <span className="error-message">{errors.firstName}</span>}                            
                    </div>
                    <div className="form-group col-md-6">
                        <label>Last name <span className="text-danger"><strong>*</strong></span></label>
                        <input 
                            className="form-control" 
                            placeholder="Last name" 
                            type="text" 
                            name="last_name"
                            value={lastName}
                            onChange={(e) => setLastName(e.target.value)}
                            autoComplete="false"                            
                            required/>
                            {errors.lastName && <span className="error-message">{errors.lastName}</span>}
                    </div>                                 
                    <div className="form-group col-md-12">
                        <label>Contact number <span className="text-danger"><strong>*</strong></span></label>
                        <input 
                            className="form-control" 
                            placeholder="Contact number" 
                            type="text"
                            name="contact_number"
                            maxLength={10}
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                            autoComplete="false"                            
                            required/>
                        {errors.phone && <span className="error-message">{errors.phone}</span>}
                    </div>
                    <div className="form-group placeholder-wrap icon-form-outline col-md-12">
                        <label>Solar installation location <span className='text-danger'>*</span></label>
                        <i className="left fa fa-search"></i>
                        <Autocomplete
                          apiKey={mapApiKey}
                          name="sol_location" 
                          className="form-control location-input" 
                          type="text"
                          placeholder='Solar installation location' 
                          onPlaceSelected={(place) => {
                            //console.log(place?.formatted_address);
                            setLocation(place?.formatted_address)
                          }}
                          options={{
                            types: ["(regions)"],
                            componentRestrictions: { country: "in" },
                          }}
                          defaultValue={location}
                          required />                           
                        <i className="right fa fa-map-marker"></i>
                    </div>                    
                    <div className="form-group col-md-12">
                        <label>Email</label>
                        <input 
                          className="form-control" 
                          placeholder="Email" 
                          type="email"
                          name="sol_email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          autoComplete="false"/>
                    </div>
                    
                    <div className="form-group col-md-10 col-sm-10 col-lg-10 col-xs-9">
                      <ReCAPTCHA
                        ref={recaptchaRef}
                        sitekey={recaptchaKey}
                        className="input-control google-recaptch-wrapper"
                        onChange={handleCaptchaChange}
                      />  
                    </div>
                  <div className="col-md-2 col-sm-2 col-lg-2 col-xs-3 text-center">
                    <span 
                      className="form-control refresh-btn-wrapper" 
                      onClick={resetCaptcha}><i className="fa fa-refresh"></i></span>
                  </div>
                  {errors.isValidCaptcha && 
                  <>
                    <div className="form-group col-md-12">
                      <span className="error-message">{errors.isValidCaptcha}</span>
                    </div>
                  </>
                  }
                    <div className="form-group col-md-12 col-sm-12 col-xs-12">
                            <p><input 
                                type="checkbox" 
                                name="chkPolicy"
                                onChange={toggleDisableButton}
                                checked = { isChecked }                                 
                                required /> You agree to our <Link to="/privacy-policy" onClick={scrollToTop}>privacy policy</Link>.</p>
                    </div>
                    <div className="form-group col-md-12 col-sm-12 col-xs-12 text-center">
                      <button 
                          className={`${isVisible} btn btn-lg btn-appointment-submit`}
                          type="submit" 
                          disabled={disableButton}>
                              Request Call Back
                      </button>                                    
                      <span className={`${spinnerClass} btn btn-lg btn-appointment-submit`}>
                          <ClipLoader
                              loading={true}
                              size={30}
                              color={"#ffffff"}/>                            
                      </span>                          
                    </div>
                    {!!(msg) && (
                      <div className="form-group col-md-12 col-sm-12 col-xs-12 custom-message text-center">
                        <span className={`${showMessage} text-center text-success`}>{msg}</span>  
                      </div>
                    )}                    
                </form>
            </div>

        </div> 
    </div>
  )
}

export default SolutionPopup